import { secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import React from 'react';

import { StepperProgressBar } from './stepper-progress-bar';
import { StepperSteps } from './stepper-steps';
import { OEText } from '../../atoms';

export interface StepperProps {
  currentStep: number;
  steps: string[];
  horizontal?: boolean;
  size?: number;
}

export function Stepper({
  steps = [],
  currentStep,
  horizontal,
  size = 64,
}: StepperProps) {
  return (
    <Container>
      {horizontal && <Title>{steps[currentStep - 1]}</Title>}
      <StepsContent
        horizontal={horizontal}
        size={size}
        stepsNumber={steps.length}
      >
        <StepperProgressBar
          size={size}
          stepsNumber={steps.length}
          horizontal={horizontal}
          currentStep={currentStep}
        />
        <StepperSteps
          currentStep={currentStep}
          size={size}
          steps={steps}
          horizontal={horizontal}
        />
      </StepsContent>
    </Container>
  );
}

interface StepsContentProps {
  stepsNumber: number;
  horizontal?: boolean;
  size: number;
}

const Container = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const StepsContent = styled.View<StepsContentProps>`
  position: relative;
  width: ${({ size, stepsNumber, horizontal }) =>
    horizontal ? size * (stepsNumber - 1) + 24 : 4}px;
  ${({ horizontal, size }) => horizontal && `height: ${size / 2}px`};
  align-items: center;
  justify-content: center;
`;

const Title = styled(OEText).attrs({
  fontFamily: secondaryFontFamily,
})`
  font-size: 18px;
  color: ${({ theme: { color } }) => color.dark1};
  font-weight: 700;
  line-height: 24px;
`;
